import axios from 'axios';
import React, { Component } from 'react';
import Pagination from "react-js-pagination";

import Footer from '../components/Footer';
import Header from '../components/Header';
import { BASEURL, FILE_DOWNLOAD_URL } from '../Config';
import { connect } from "react-redux";
import { compose } from "redux";
import { getUserData, getisAuthenticated, getSchool } from '../modules/reducers';
import { setSelectedOrderId } from '../modules/actions';

class Orders extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orders: [],
            orderProducts: [],
            docketImg: '',
            activePage: 1,
            itemsPerPage: 5,
            totalItemsCount: 0,
            selectedOrderId: '',
            selectedOrderTotal: 0,
            selectedOrderShippingCharges: 0,
            isLoading: false
        }
    }

    componentDidMount() {
        const { user } = this.props;
        if (user?._id || user?.parentId) {
            this.fetchOrders(1);
        }
    }

    componentDidUpdate(prevProps) {
        const userId = this.props.user?._id || this.props.user?.parentId;
        const prevUserId = prevProps.user?._id || prevProps.user?.parentId;
        if (userId && !prevUserId) {
            this.fetchOrders(1);
        }
    }

    getOrderStatusStyle(status) {
        switch (status) {
            case 'Order Placed':
                return { backgroundColor: '#cfe2ff', color: '#084298', padding: '3px 10px', borderRadius: '4px', fontSize: '0.8em', whiteSpace: 'nowrap' };
            case 'Order Processing':
                return { backgroundColor: '#fff3cd', color: '#664d03', padding: '3px 10px', borderRadius: '4px', fontSize: '0.8em', whiteSpace: 'nowrap' };
            case 'Order Completed':
                return { backgroundColor: '#d1e7dd', color: '#0a3622', padding: '3px 10px', borderRadius: '4px', fontSize: '0.8em', whiteSpace: 'nowrap' };
            default:
                return { backgroundColor: '#e2e3e5', color: '#41464b', padding: '3px 10px', borderRadius: '4px', fontSize: '0.8em', whiteSpace: 'nowrap' };
        }
    }

    fetchOrders(pageNumber) {
        const { user } = this.props;
        const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const schoolId = this.props.school?._id;
        const url = user.parentId
            ? `${BASEURL}/api/v1/order/fetchAllByParentId/${user.parentId}?page=${pageNumber}&limit=${this.state.itemsPerPage}&timezone=${timezone}${schoolId ? `&schoolId=${schoolId}` : ''}`
            : `${BASEURL}/api/v1/order/fetchAllByStudentId/${user._id}?page=${pageNumber}&limit=${this.state.itemsPerPage}&timezone=${timezone}`;

        this.setState({ isLoading: true });
        axios.get(url)
            .then(res => {
                if (res.data.success) {
                    this.setState({
                        orders: res.data.orders,
                        activePage: pageNumber,
                        totalItemsCount: res.data.count,
                        isLoading: false
                    });
                }
            })
            .catch(err => {
                console.log(err);
                this.setState({ isLoading: false });
            });
    }


    handleOnClickViewModal(idx) {
        let orders = this.state.orders;
        let order = orders[idx];
        // console.log('order', order);
        let orderProducts = this.state.orderProducts;
        orderProducts = order.products;
        // console.log('orderProducts', orderProducts);

        this.setState({
            selectedOrderId: order.orderId,
            selectedOrderTotal: order.orderTotal,
            selectedOrderShippingCharges: order.shippingCharges,
            orderProducts,
            docketImg: order.docketImg
        })
    }

    viewInvoice(order) {
        this.props.setSelectedOrderId(order._id);
        this.props.history.push('viewOrder')
    }

    handlePageChange(pageNumber) {
        this.fetchOrders(pageNumber);
    }
    render() {
        const { orders, activePage, itemsPerPage, totalItemsCount, isLoading } = this.state;
        const schoolPath = `school/${this.props.school.slug || this.props.school.name}`;

        return (
            <div className="site-wrap">
                <Header page={'myOrders'} />
                <div className="bg-light py-3">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 mb-0"><a href={schoolPath}>Home</a> <span className="mx-2 mb-0">/</span> <strong className="text-black">My Orders</strong></div>
                        </div>
                    </div>
                </div>
                <div className="site-section">
                    <div className="container">
                        <div className="row">
                            <div className='col-md-12'>
                                {isLoading ? (
                                    <div className="text-center py-5">
                                        <div className="spinner-border text-primary" role="status">
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                        <p className="mt-2 text-muted">Loading orders...</p>
                                    </div>
                                ) : orders.length > 0 ? (
                                    <>
                                        {orders.map((order, index) => (
                                            <div className='card mb-3' key={index}>
                                                <div className='card-body'>
                                                    <div className='row'>
                                                        <div className='col-md-6'>
                                                            <p className='card-text mb-0'>
                                                                <strong>Order ID:</strong> <span className='text-primary'>#{order.orderId}</span>
                                                            </p>
                                                            <p className='card-text mb-0'>
                                                                <strong>Order Date:</strong> <span className='text-primary'>{order.createdDate}</span>
                                                            </p>
                                                            <p className='card-text mb-0'>
                                                                <strong>Order Status:</strong> <span style={this.getOrderStatusStyle(order.orderStatus)}>{order.orderStatus}</span>
                                                                {order.products?.[0]?.orderType === 'uniformProducts' && (
                                                                    <span className='badge badge-warning ml-2'>Uniform Products Order</span>
                                                                )}
                                                            </p>
                                                            <p className='card-text mb-0'>
                                                                <strong>Order Total:</strong> <span className='text-primary'>₹ {order.orderTotal + order.shippingCharges}</span>
                                                            </p>
                                                            <p className='card-text mb-0'>
                                                                <strong>Shipping Address:</strong> <span className='text-primary'>{order.address}</span>
                                                            </p>
                                                        </div>
                                                        <div className='col-md-6'>
                                                            {order.studentName && <p className='card-text mb-0'>
                                                                <strong>Student Name:</strong> <span className='text-primary'>{order.studentName}</span>
                                                            </p>}
                                                            {order.products?.[0]?.className && <p className='card-text mb-0'>
                                                                <strong>Class:</strong> <span className='text-primary'>{order.products[0].className}</span>
                                                            </p>}
                                                            <p className='card-text mb-2'>
                                                                <strong>Tracking Number:</strong> <span className='text-primary'>{order.trackingId ? order.trackingId : 'Will be updated soon'}</span>
                                                            </p>
                                                            <button className='btn btn-primary mr-1 mb-2' onClick={() => this.handleOnClickViewModal(index)} data-toggle="modal" data-target="#viewOrderModal">View Product Details</button>
                                                            {order.orderStatus === 'Order Completed' &&
                                                                <a className='btn btn-primary mr-1 mb-2' href={`${FILE_DOWNLOAD_URL}/${order.docketImg}`} target={'_blank'}>View Tracking Image</a>
                                                            }
                                                            <button className='btn btn-primary mb-2' onClick={() => this.viewInvoice(order)}>Invoice</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                        <div className="row">
                                            <div className="col-md-12 text-center">
                                                <div className="site-block-27">
                                                    <Pagination
                                                        activePage={activePage}
                                                        itemsCountPerPage={itemsPerPage}
                                                        totalItemsCount={totalItemsCount}
                                                        pageRangeDisplayed={5}
                                                        onChange={this.handlePageChange.bind(this)}
                                                        prevPageText={<i className='fa fa-chevron-left'></i>}
                                                        nextPageText={<i className='fa fa-chevron-right'></i>}
                                                        firstPageText={<i className='fa fa-angle-double-left'></i>}
                                                        lastPageText={<i className='fa fa-angle-double-right'></i>}
                                                        disabledClass={'paginationDisabled'}
                                                        innerClass={'paginationInnerClass'}
                                                        activeClass={'activePaginationElement'}
                                                        activeLinkClass={'activePaginationLinkClass'}
                                                        itemClass={'paginationItemClass'}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                ) : 'No Orders Placed'}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="viewOrderModal" tabIndex={-1} role="dialog" aria-labelledby="viewOrderModalTitle" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-lg" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title text-black" id="viewOrderModalLongTitle">View Product Details for Order ID: <strong>#{this.state.selectedOrderId}</strong></h5>
                                <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                    <span aria-hidden="true">×</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-md-12 mb-3'>
                                        <p className='card-text'>
                                            <strong>Products Total:</strong> <span className='text-primary mr-2'>₹ {this.state.selectedOrderTotal}</span>
                                            <strong>Shipping Charges:</strong> <span className='text-primary mr-2'>₹ {this.state.selectedOrderShippingCharges}</span>
                                        </p>
                                    </div>
                                    {this.state.orderProducts.length > 0 ? <>
                                        {this.state.orderProducts.map((item, idx) => (
                                            <div className='col-md-12'>
                                                <div className='card mb-3'>
                                                    <div className='card-body'>
                                                        <strong className='text-black'>Product {idx + 1}</strong>
                                                        <div>
                                                            <p className='mb-0 text-black'><strong>Name: </strong>{item.productSetName}</p>
                                                            <p className='mb-0 text-black'><strong>Product Total: </strong>{item.price}</p>
                                                        </div>
                                                        <p className='text-black text-center productDetails'><strong>Product Details</strong></p>
                                                        {item.orderType === 'uniformProducts' && item.categories.uniformProducts && item.categories.uniformProducts.length > 0 ? (
                                                            <>
                                                                <h6 className='text-black mb-2'>Product Type: <span className="text-primary">Uniform Products</span></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                <th>Size</th>
                                                                                <th>Quantity</th>
                                                                                <th>Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.uniformProducts.map((element, index) => (
                                                                                <tr key={index}>
                                                                                    <td>{element.name}</td>
                                                                                    <td>{element.selectedSize}</td>
                                                                                    <td>{element.quantity || 1}</td>
                                                                                    <td>₹{element.price}</td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                            </>
                                                        ) : null}
                                                        {item.categories.languageProducts && item.categories.languageProducts.length > 0 ?
                                                            <>
                                                                <h6 className='text-black mb-2'>Language: <sapn className="text-primary">{item.languageName}</sapn></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                {/* <th>Qty</th> */}
                                                                                {/* <th>Unit Price (Rs.)</th> */}
                                                                                <th>Total Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.languageProducts.map((element, index) => {
                                                                                return (
                                                                                    <tr >
                                                                                        <td>{element.pname}</td>
                                                                                        {/* <td>{element.qty}</td> */}
                                                                                        {/* <td>₹{element.price}</td> */}
                                                                                        <td>₹{element.total}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </>
                                                            : ''}
                                                        {item.categories.books && item.categories.books.length > 0 ?
                                                            <>
                                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Books</sapn></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                {/* <th>Qty</th> */}
                                                                                {/* <th>Unit Price (Rs.)</th> */}
                                                                                <th>Total Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.books.map((element, index) => {
                                                                                return (
                                                                                    <tr >
                                                                                        <td>{element.pname}</td>
                                                                                        {/* <td>{element.qty}</td> */}
                                                                                        {/* <td>₹{element.price}</td> */}
                                                                                        <td>₹{element.total}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </>
                                                            : ''}
                                                        {item.categories.stationery && item.categories.stationery.length > 0 ?
                                                            <>
                                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Stationery</sapn></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                {/* <th>Qty</th> */}
                                                                                {/* <th>Unit Price (Rs.)</th> */}
                                                                                <th>Total Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.stationery.map((element, index) => {
                                                                                return (
                                                                                    <tr >
                                                                                        <td>{element.pname}</td>
                                                                                        {/* <td>{element.qty}</td> */}
                                                                                        {/* <td>₹{element.price}</td> */}
                                                                                        <td>₹{element.total}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </>
                                                            : ''}
                                                        {item.categories.uniform && item.categories.uniform.length > 0 ?
                                                            <>
                                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Uniform</sapn></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                <th>Stitching</th>
                                                                                {/* <th>Unit Price (Rs.)</th> */}
                                                                                <th>Total Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.uniform.map((element, index) => {
                                                                                return (
                                                                                    <tr key={index}>
                                                                                        <td>{element.pname}</td>
                                                                                        <td>
                                                                                            {element.withStitching ? (
                                                                                                <span>
                                                                                                    With Stitching
                                                                                                    {element.measurementData && (
                                                                                                        <span className='text-muted'> &nbsp;(Size: {element.measurementData.size}, Gender: {element.measurementData.gender})</span>
                                                                                                    )}
                                                                                                </span>
                                                                                            ) : 'Without Stitching'}
                                                                                        </td>
                                                                                        {/* <td>₹{element.price}</td> */}
                                                                                        <td>₹{element.total}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>
                                                                {item.categories.uniform.filter(el => el.withStitching && el.measurementData).map((el, mIdx) => {
                                                                    const d = el.measurementData;
                                                                    const measurementFields = [
                                                                        { name: 'chestBust', label: 'Chest / Bust (inches)' },
                                                                        { name: 'waist', label: 'Waist (inches)' },
                                                                        { name: 'hip', label: 'Hip (inches)' },
                                                                        { name: 'shoulderWidth', label: 'Shoulder Width (inches)' },
                                                                        { name: 'neck', label: 'Neck (inches)' },
                                                                        { name: 'ankle', label: 'Ankle (inches)' },
                                                                        { name: 'sleeveLength', label: 'Sleeve Length (inches)' },
                                                                        { name: 'upperArmBicep', label: 'Upper Arm / Bicep (inches)' },
                                                                        { name: 'wrist', label: 'Wrist (inches)' },
                                                                        { name: 'armholeScye', label: 'Armhole / Scye (inches)' },
                                                                        { name: 'frontLength', label: 'Front Length (inches)' },
                                                                        { name: 'fullBodyLength', label: 'Full Body Length (inches)' },
                                                                        { name: 'inseam', label: 'Inseam (inches)' },
                                                                        { name: 'outseamSideLength', label: 'Outseam / Side Length (inches)' },
                                                                        { name: 'thigh', label: 'Thigh (inches)' },
                                                                        { name: 'knee', label: 'Knee (inches)' },
                                                                    ];
                                                                    const filledFields = measurementFields.filter(f => d.measurements && d.measurements[f.name] != null && d.measurements[f.name] !== '');
                                                                    return (
                                                                        <div className='card mb-2' key={mIdx} style={{ backgroundColor: '#f8f9fa' }}>
                                                                            <div className='card-body py-2'>
                                                                                <p className='mb-2 text-black'><strong>Measurement Details — {el.pname}</strong></p>
                                                                                <div className='row mb-1'>
                                                                                    <div className='col-sm-3'>
                                                                                        <small className='text-muted d-block'>Gender</small>
                                                                                        <strong>{d.gender || '—'}</strong>
                                                                                    </div>
                                                                                    <div className='col-sm-3'>
                                                                                        <small className='text-muted d-block'>Size</small>
                                                                                        <strong>{d.size || '—'}</strong>
                                                                                    </div>
                                                                                </div>
                                                                                {filledFields.length > 0 && (
                                                                                    <>
                                                                                        <hr className='my-2' />
                                                                                        <div className='row'>
                                                                                            {filledFields.map(f => (
                                                                                                <div className='col-sm-4 mb-1' key={f.name}>
                                                                                                    <small className='text-muted d-block'>{f.label}</small>
                                                                                                    <strong>{d.measurements[f.name]}</strong>
                                                                                                </div>
                                                                                            ))}
                                                                                        </div>
                                                                                    </>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    );
                                                                })}
                                                            </>
                                                            : ''}
                                                        {item.categories.clothing && item.categories.clothing.length > 0 ?
                                                            <>
                                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Clothing</sapn></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                {/* <th>Qty</th> */}
                                                                                {/* <th>Unit Price (Rs.)</th> */}
                                                                                <th>Total Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.clothing.map((element, index) => {
                                                                                return (
                                                                                    <tr >
                                                                                        <td>{element.pname}</td>
                                                                                        {/* <td>{element.qty}</td> */}
                                                                                        {/* <td>₹{element.price}</td> */}
                                                                                        <td>₹{element.total}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </>
                                                            : ''}
                                                        {item.categories.accessories && item.categories.accessories.length > 0 ?
                                                            <>
                                                                <h6 className='text-black mb-2'>Product Type: <sapn className="text-primary">Accessories</sapn></h6>
                                                                <div className='table-responsive mt-3 mb-3'>
                                                                    <table className='table table-bordered'>
                                                                        <thead className='thead thead-dark'>
                                                                            <tr>
                                                                                <th>Product Name</th>
                                                                                {/* <th>Qty</th> */}
                                                                                {/* <th>Unit Price (Rs.)</th> */}
                                                                                <th>Total Price</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.categories.accessories.map((element, index) => {
                                                                                return (
                                                                                    <tr >
                                                                                        <td>{element.pname}</td>
                                                                                        {/* <td>{element.qty}</td> */}
                                                                                        {/* <td>₹{element.price}</td> */}
                                                                                        <td>₹{element.total}</td>
                                                                                    </tr>
                                                                                )
                                                                            })}
                                                                        </tbody>
                                                                    </table>
                                                                </div>

                                                            </>
                                                            : ''}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </> : ''}

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        user: getUserData(state),
        isAuthenticated: getisAuthenticated(state),
        school: getSchool(state),
    }
}

const mapDispatchToProps = (dispatch) => ({
    setSelectedOrderId: (orderId) => dispatch(setSelectedOrderId(orderId)),
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(Orders);